// GET: Patient Waiting List API

import { IBookingGiftClaimReminder, IBookingUpdateModuleType } from "./Bookings";

export interface IPatientWaitingListUserDetails {
  id: string;
  name: string;
  customer_type: string;
  mobile: string;
  custom_address?: string;
}

export interface IPatientWaitingListIdNameInterface {
  id: string;
  name: string;
  service_type?: string;
}

export interface IPatientWaitingListServiceDetails extends IPatientWaitingListIdNameInterface {}

export interface IPatientWaitingListClinicDetails {
  id: string;
  name: string;
  display_name: string;
  address: string;
}

export interface IPatientWaitingListPetDetails {
  name: string;
  id: string;
  pet_breed_id: number;
  pet_species_type_id: string;
  vaccination_status: boolean | null;
  risk_case: boolean | null;
  pet_breed: string;
  high_risk: boolean;
  has_birthday?: boolean;
}

export interface IPaymentDetails {
  payment_link: string;
  amount: number;
  payment_status: boolean;
  is_refundable: boolean;
}

export interface IPWLmetaInformation {
  wait_timer: "0h 1m 43s";
  wait_time: "0h 1m 43s";
  tat_time: null;
  check_in: "2:26 PM";
}

export interface IBookingEMRDetails {
  emr_status: string;
  emr_id?: string;
}
export interface IPatientWaitingListData {
  vaccination: string; // Diff
  booking_id: string;
  booking_fee_amount: number;
  clinic_id: string;
  booking_status: string;
  appointment_note: string;
  persona_discount_comments?: string[];
  user_id: string;
  pet_id: string;
  service_id: string;
  booking_start_date: string;
  booking_start_time: string;
  booking_start_date_time: string;
  booking_end_date: string;
  booking_end_date_time: string;
  booking_end_time: string;
  staff_id: string | null;
  subservice_id: string | null;
  is_member: string; // diff
  user_details: IPatientWaitingListUserDetails | null; // diff
  service_details: IPatientWaitingListServiceDetails | null;
  subservice_details: IPatientWaitingListIdNameInterface | null;
  clinic_details: IPatientWaitingListClinicDetails | null;
  pet_details: IPatientWaitingListPetDetails | null;
  staff_details: IPatientWaitingListIdNameInterface | null;
  created_by: string | null;
  payment_details?: IPaymentDetails | null;
  emr_details: IBookingEMRDetails | null;
  isappdownloaded?: boolean;
  allocation_status?: string | null;
  vb_link?: string;
  invoice_details: IPwlInvoice[];
  meta_data?: IPWLmetaInformation | null;
  reason?: string;
  update_pg?: boolean;
  // Gifts offered with an Upcoming booking that the customer still has to claim in the app
  gift_details?: IBookingGiftClaimReminder[];
}
export interface IPwlInvoice {
  invoice_id: string;
  invoice_link: string;
  file_name: string;
}

export const PWL_DEFAULT_PAGE_SIZE = 100;
export const PWL_PAGE_SIZE_OPTIONS = [50, 100, 200, 500];

export interface IPatientWaitingListPagination {
  total: number;
  page: number;
  limit: number;
}

export interface IPatientWaitingListPage {
  bookings: IPatientWaitingListData[];
  pagination: IPatientWaitingListPagination;
}

export interface IPatientWaitingListResponse {
  status: boolean;
  message: string;

  data: IPatientWaitingListPage | null;
}


export interface IAtHomeListingResponse {
  status: boolean;
  message: string;

  data: IPatientWaitingListData[] | null;
}

//Patient Waiting list stats api
export type ValidBookingStatuses =
  | "Upcoming"
  | "Waiting"
  | "Completed"
  | "Attending"
  | "on_hold"
  | "Failed"
  | "Cancelled";

//Patient Waiting list stats api
export type ValidBookingStatusesNew = "Upcoming" | "Waiting" | "Completed" | "Attending" | "Cancelled";

export interface IPatientWaitingListFiltersParamsBody {
  date: string; // YYYY-MM-DD
  clinic_ids: Array<string>;
  booking_statuses: Array<ValidBookingStatusesNew>;
  service_ids: Array<string>;
  staff_ids: Array<string>;
  created_by?: Array<string>;

  page?: number;
  limit?: number;
}
export interface IPatientWaitingStatsParamsBody {
  date: string; // YYYY-MM-DD
  clinic_ids: Array<string>;
  service_ids: Array<string>;
  staff_ids: Array<string>;
  created_by?: Array<string>;
}
export interface IPatientWaitingStatsIdCountInterface {
  id: string;
  count: number | null;
}

export interface IPatientWaitingStatsData {
  Total: IPatientWaitingStatsIdCountInterface;
  Upcoming: IPatientWaitingStatsIdCountInterface;
  Completed: IPatientWaitingStatsIdCountInterface;
  Attending: IPatientWaitingStatsIdCountInterface;
  Cancelled: IPatientWaitingStatsIdCountInterface;
  Waiting: IPatientWaitingStatsIdCountInterface;
}
export interface IPatientWaitingStatsResponse {
  status: boolean;
  message: string;
  data: IPatientWaitingStatsData[];
}

export interface IAtHomeBookingStatusSummaryCount {
  count: number;
  id: string | null;
}

export interface IAtHomeBookingStatusSummaryData {
  Total: IAtHomeBookingStatusSummaryCount;
  Attending: IAtHomeBookingStatusSummaryCount;
  Failed: IAtHomeBookingStatusSummaryCount;
  Cancelled: IAtHomeBookingStatusSummaryCount;
  Completed: IAtHomeBookingStatusSummaryCount;
  "On Hold": IAtHomeBookingStatusSummaryCount;
  Upcoming: IAtHomeBookingStatusSummaryCount;
  Waiting: IAtHomeBookingStatusSummaryCount;
  Confirmed: IAtHomeBookingStatusSummaryCount;
  "In Transit": IAtHomeBookingStatusSummaryCount;
}

export interface IAtHomeBookingStatusSummaryResponse {
  status: boolean;
  message: string;
  data: IAtHomeBookingStatusSummaryData[];
}

export interface IAtHomeListingFiltersParamsBody {
  date: string;
  booking_status: string[];
  clinic_id: string[];
  sub_service_id?: string[];
  staff_id: string[];
  created_by?: string[];
}

export interface IAtHomeBookingStatusSummaryParamsBody {
  booking_date: string; // YYYY-MM-DD
  clinic_id: Array<string>;
  sub_service_id?: Array<string>;
  staff_id?: Array<string>;
  created_by?: Array<string>;
}

//Patient waiting list action button
export interface IPatientWaitingListActionBodyComments {
  value: string;
}
export interface IPatientWaitingListActionBodyCurrentLocation {
  latitude: string;
  longitude: string;
}
export interface IPatientWaitingListActionBodySlotDetails {
  slot_id: string;
  staff_id: string;
}
export interface IPatientWaitingListActionBodyStaffDetailsVetBuddyData {
  vetbuddy_staff_id: string;
  vetbuddy_instance_id: string;
}
export interface IPatientWaitingListActionBodyStaffDetails {
  id: string;
  staff_name: string;
  vetbuddy_data?: IPatientWaitingListActionBodyStaffDetailsVetBuddyData[] | null;
}
export interface IPatientWaitingListActionBodyServiceDetails {
  service_name: string;
  service_id: string;
  sub_service_id: string | null;
  sub_service_name: string | null;
  service_type_id?: string;
}
export interface IPatientWaitingListActionBodyClinicDetails {
  id: string;
  clinic_name?: string;
  vetbuddy_clinic_name?: string;
  vetbuddy_instance_id?: string;
  location_url?: string;
}
export interface IPatientWaitingListActionBodyPetDetailsVetBuddyData {
  vetbuddy_patient_id: string;
  vetbuddy_instance_id: string;
}
export interface IPatientWaitingListActionBodyPetDetails {
  id: string;
  pet_name?: string;
  pet_gender?: string;
  pet_dob?: string;
  pet_image_url?: string;
  pet_weight?: string;
  pet_species_type_id?: string;
  pet_breed_id?: string;
  pet_breed?: string;
  vetbuddy_data?: IPatientWaitingListActionBodyPetDetailsVetBuddyData[] | null;
}
export interface IPatientWaitingListActionBodyMobileData {
  mobile: string;
  mobile_type: string;
}
export interface IPatientWaitingListActionBodyVetBuddyData {
  vetbuddy_client_id: string;
  vetbuddy_instance_id: string;
}
export interface IAtHomeBookingStatusSummaryCount {
  count: number;
  id: string | null;
}

export interface IAtHomeBookingStatusSummaryData {
  Total: IAtHomeBookingStatusSummaryCount;
  Attending: IAtHomeBookingStatusSummaryCount;
  Failed: IAtHomeBookingStatusSummaryCount;
  Cancelled: IAtHomeBookingStatusSummaryCount;
  Completed: IAtHomeBookingStatusSummaryCount;
  "On Hold": IAtHomeBookingStatusSummaryCount;
  Upcoming: IAtHomeBookingStatusSummaryCount;
  Waiting: IAtHomeBookingStatusSummaryCount;
  Confirmed: IAtHomeBookingStatusSummaryCount;
  "In Transit": IAtHomeBookingStatusSummaryCount;
}

export interface IAtHomeBookingStatusSummaryResponse {
  status: boolean;
  message: string;
  data: IAtHomeBookingStatusSummaryData[];
}

export interface IAtHomeListingFiltersParamsBody {
  date: string;
  booking_status: string[];
  clinic_id: string[];
  sub_service_id?: string[];
  staff_id: string[];
  created_by?: string[];
}

export interface IAtHomeBookingStatusSummaryParamsBody {
  booking_date: string; // YYYY-MM-DD
  clinic_id: Array<string>;
  sub_service_id?: Array<string>;
  staff_id?: Array<string>;
  created_by?: Array<string>;
}

export interface IPatientWaitingListActionBodyUserDetails {
  id: string;
  user_name?: string;
  user_mobile?: string;
  vetbuddy_data?: IPatientWaitingListActionBodyVetBuddyData[] | null;
  mobile_data?: IPatientWaitingListActionBodyMobileData[] | null;
}

export interface IPatientWaitingListActionBody {
  source_module?: IBookingUpdateModuleType;
  booking_status: string;
  booking_date: string;
  start_time: string;
  end_time: string;
  groomer_id?: Array<string>;
  booking_start_date_time: string;
  booking_end_date_time: string;
  user_details: IPatientWaitingListActionBodyUserDetails;
  pet_details: IPatientWaitingListActionBodyPetDetails;
  clinic_details: IPatientWaitingListActionBodyClinicDetails;
  service_details: IPatientWaitingListActionBodyServiceDetails;
  staff_details: IPatientWaitingListActionBodyStaffDetails;

  comments?: string;
  created_by?: string;
  source_id?: string;
  updated_by?: string;
}
export interface IPatientWaitingListActionData {
  booking_id: string;
}
export interface IPatientWaitingListActionResponse {
  status: boolean;
  message: string;
  data: IPatientWaitingListActionData | null;
}

// groomers

export interface IPatientWaitingListGroomesData {
  id: "string";
  name: "string";
}
export interface IPatientWaitingListGroomesResponse {
  status: boolean;
  message: string;
  data: IPatientWaitingListGroomesData[] | null;
}

// pet ready whatsapp post api

export interface IPatientWaitingListPetReadyWhatsapp {
  status: boolean;
  message: string;
  data: null;
}

// Teleconsultation
export interface ITeleconsultationUserDoctorMeetDetailsResponseData {
  user_name: string;
  appointment_time: number;
  pet_name: string;
  doctor_name: string;
  user_meet_url: string;
  doctor_meet_url: string;
  service_name: string;
}

export interface ITeleconsultationUserDoctorMeetDetailsResponse {
  status: boolean;
  message: string;
  data: ITeleconsultationUserDoctorMeetDetailsResponseData;
}

export interface ITeleconsultationUserDoctorMeetDetailsResponsePostBody {
  booking_id: string;
  send_msg_to: string;
}

export interface ITeleconsultationUserDoctorMeetDetailsPostResponse {
  status: boolean;
  message: string;
  data: null;
}
